import { supabase, supabaseUrl, supabaseAnonKey } from '../supabase/client';

// Holt ein eingebettetes cid:-Bild on-demand aus dem Postfach (Edge Function anhang-datei).
// Bewusst roher fetch statt supabase.functions.invoke: invoke liest nur
// application/octet-stream/pdf als Blob — die Function liefert für sichere Bilder
// aber echte image/*-Typen, die invoke als Text zerstören würde.
export async function ladeCidBild(emailId: string, contentId: string): Promise<Blob> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) throw new Error('Keine aktive Sitzung');
  const res = await fetch(`${supabaseUrl}/functions/v1/anhang-datei`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${session.access_token}`,
      apikey: supabaseAnonKey,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ emailId, contentId }),
  });
  if (!res.ok) {
    let msg = `cid-Bild konnte nicht geladen werden (${res.status})`;
    try { const b = await res.json(); if (b?.error) msg = b.error; } catch { /* binär/leer */ }
    throw new Error(msg);
  }
  return res.blob();
}
